var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCriticalInstall1Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8361_804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4108 8.33332C18.7965 10.2011 18.5216 12.1428 17.6321 13.8348C16.7425 15.5268 15.292 16.8667 13.5225 17.6311C11.7529 18.3955 9.7713 18.5381 7.90807 18.0353C6.04483 17.5325 4.4126 16.4145 3.28358 14.8678C2.15456 13.3212 1.59699 11.4394 1.70386 9.53615C1.81072 7.63294 2.57556 5.8234 3.87082 4.4093C5.16609 2.9952 6.91349 2.06202 8.82161 1.76537C10.7297 1.46872 12.6833 1.82654 14.3564 2.77916",
    stroke: "#D08700",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.60059 9.16659L10.1341 11.6666L18.579 3.33325",
    stroke: "#D08700",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8361_804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.2679,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriticalInstall1Icon);
export default __webpack_public_path__ + "static/media/critical_install_1_icon.9cdc119293e45fb374a6dfe77ae925d2.svg";
export { ForwardRef as ReactComponent };